import React, { useState } from "react";
import Navbar from "./components/Navbar";
import CartPage from "./pages/CartPage";
import HomePage from "./pages/HomePage";

const App = () => {
  const [route, setRoute] = useState("home");
  return (
    <div>
      <Navbar setRoute={setRoute} />
      {route === "home" ? <HomePage /> : <CartPage />}
    </div>
  );
};

export default App;
